import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkPreviewInvoiceRequest = { invoices: '_invoice' };
var _bulkPreviewInvoiceResponse = { invoices: '_invoice' };
var _createInvoiceRequest = { invoice: '_invoice' };
var _createInvoiceResponse = { invoice: '_invoice' };
var _deleteInvoiceRequest = {};
var _deleteInvoiceResponse = {};
var _enableOnlinePaymentRequest = {};
var _enableOnlinePaymentResponse = { invoice: '_invoice' };
var _getInvoiceByInvoiceNumberRequest = {};
var _getInvoiceByInvoiceNumberResponse = { invoice: '_invoice' };
var _getInvoiceRequest = {};
var _getInvoiceResponse = { invoice: '_invoice' };
var _invoice = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    latestPaymentAttempt: '_latestPaymentAttempt',
};
var _latestPaymentAttempt = { dateAttempt: 'google.protobuf.Timestamp' };
var _markAsCanceledRequest = {};
var _markAsCanceledResponse = { invoice: '_invoice' };
var _markAsPaidRequest = {};
var _markAsPaidResponse = { invoice: '_invoice' };
var _previewInvoiceRequest = { invoice: '_invoice' };
var _previewInvoiceResponse = { invoice: '_invoice' };
var _queryInvoiceRequest = {};
var _queryInvoiceResponse = { invoices: '_invoice' };
var _refundInvoiceRequest = {};
var _refundInvoiceResponse = { invoice: '_invoice' };
var _reviseInvoiceRequest = { invoice: '_invoice' };
var _reviseInvoiceResponse = { invoice: '_invoice' };
var _updateInvoiceOriginRequest = {};
var _updateInvoiceOriginResponse = { invoice: '_invoice' };
function resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/billing-invoices',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/billing-invoices',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves an invoice. */
export function getInvoice(payload) {
    var _a = serializer(_getInvoiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getInvoiceResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __getInvoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.GetInvoice',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInvoice.fromReq = fromReq;
    __getInvoice.__isAmbassador = true;
    return __getInvoice;
}
/** Retrieves an invoice by invoice number. */
export function getInvoiceByInvoiceNumber(payload) {
    var _a = serializer(_getInvoiceByInvoiceNumberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getInvoiceByInvoiceNumberResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __getInvoiceByInvoiceNumber(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.GetInvoiceByInvoiceNumber',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/by-number/{invoiceNumber}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInvoiceByInvoiceNumber.fromReq = fromReq;
    __getInvoiceByInvoiceNumber.__isAmbassador = true;
    return __getInvoiceByInvoiceNumber;
}
/** Creates an invoice. */
export function createInvoice(payload) {
    var _a = serializer(_createInvoiceRequest, { _invoice: _invoice, _latestPaymentAttempt: _latestPaymentAttempt }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createInvoiceResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __createInvoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.CreateInvoice',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createInvoice.fromReq = fromReq;
    __createInvoice.__isAmbassador = true;
    return __createInvoice;
}
/**
 * Creates multiple invoice previews.
 *
 *
 * You can use this endpoint to calculate `totals` for multiple invoices
 * without creating actual invoices. Preview invoices aren't saved in the
 * database.
 */
export function bulkPreviewInvoice(payload) {
    var _a = serializer(_bulkPreviewInvoiceRequest, { _invoice: _invoice, _latestPaymentAttempt: _latestPaymentAttempt }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkPreviewInvoiceResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __bulkPreviewInvoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.BulkPreviewInvoice',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/bulk-preview',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkPreviewInvoice.fromReq = fromReq;
    __bulkPreviewInvoice.__isAmbassador = true;
    return __bulkPreviewInvoice;
}
/**
 * Creates an invoice preview.
 *
 *
 * You can use this endpoint to calculate the invoice `totals` without
 * creating an actual invoice. The preview invoice isn't saved in the
 * database.
 */
export function previewInvoice(payload) {
    var _a = serializer(_previewInvoiceRequest, { _invoice: _invoice, _latestPaymentAttempt: _latestPaymentAttempt }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewInvoiceResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __previewInvoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.PreviewInvoice',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/preview',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewInvoice.fromReq = fromReq;
    __previewInvoice.__isAmbassador = true;
    return __previewInvoice;
}
/**
 * Refunds an invoice.
 *
 * This endpoint refunds the full invoice amount, based on the invoice's last transaction.
 */
export function refundInvoice(payload) {
    var _a = serializer(_refundInvoiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_refundInvoiceResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __refundInvoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.RefundInvoice',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/{id}/refund',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __refundInvoice.fromReq = fromReq;
    __refundInvoice.__isAmbassador = true;
    return __refundInvoice;
}
/**
 * Updates an invoice.
 *
 *
 * You can only revise invoices with status `"OPEN"`.
 */
export function reviseInvoice(payload) {
    var _a = serializer(_reviseInvoiceRequest, { _invoice: _invoice, _latestPaymentAttempt: _latestPaymentAttempt }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reviseInvoiceResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __reviseInvoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.ReviseInvoice',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/revise',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reviseInvoice.fromReq = fromReq;
    __reviseInvoice.__isAmbassador = true;
    return __reviseInvoice;
}
/**
 * Deletes an invoice.
 *
 *
 * The invoice isn't deleted in case you provide an out dated `revision`. But
 * it's always deleted when you omit `revision`.
 */
export function deleteInvoice(payload) {
    var _a = serializer(_deleteInvoiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteInvoiceResponse, {}).fromJSON;
    function __deleteInvoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'DELETE',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.DeleteInvoice',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteInvoice.fromReq = fromReq;
    __deleteInvoice.__isAmbassador = true;
    return __deleteInvoice;
}
/** Changes an invoice's `status` to `"CANCELED"`. */
export function markAsCanceled(payload) {
    var _a = serializer(_markAsCanceledRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsCanceledResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __markAsCanceled(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.MarkAsCanceled',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/{id}/mark-as-canceled',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsCanceled.fromReq = fromReq;
    __markAsCanceled.__isAmbassador = true;
    return __markAsCanceled;
}
/**
 * Creates an [order in Cashier for an online payment](https://dev.wix.com/docs/rest/payments/wix-cashier/pay/order#order-object)
 * that belongs to the specified invoice. Then, updates the `paymentOrderId` field of the
 * invoice with the ID of the newly created Cashier order.
 *
 *
 * The original invoice's `collectionMethod` must be `"OFFLINE"`, otherwise
 * the call fails. You can call this endpoint in case you want to allow an
 * online payment for the current invoice of a subscription that had been paid
 * offline until now.
 *
 * The `collectionMethod` remains `"OFFLINE"` until the invoice has been paid
 * for by an online transaction.
 */
export function enableOnlinePayment(payload) {
    var _a = serializer(_enableOnlinePaymentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_enableOnlinePaymentResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __enableOnlinePayment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.EnableOnlinePayment',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/{id}/enable-online-payment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __enableOnlinePayment.fromReq = fromReq;
    __enableOnlinePayment.__isAmbassador = true;
    return __enableOnlinePayment;
}
/** Changes an invoice's `status` to `"PAID"`. */
export function markAsPaid(payload) {
    var _a = serializer(_markAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsPaidResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __markAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.MarkAsPaid',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/{id}/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsPaid.fromReq = fromReq;
    __markAsPaid.__isAmbassador = true;
    return __markAsPaid;
}
/**
 * Retrieves a list of invoices, filtered by
 * [Cashier order ID](https://dev.wix.com/docs/rest/api-reference/wix-cashier/cashier-pay/order/order-object).
 */
export function queryInvoice(payload) {
    var _a = serializer(_queryInvoiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryInvoiceResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __queryInvoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.QueryInvoice',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryInvoice.fromReq = fromReq;
    __queryInvoice.__isAmbassador = true;
    return __queryInvoice;
}
export function updateOrigin(payload) {
    var _a = serializer(_updateInvoiceOriginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateInvoiceOriginResponse, {
        _invoice: _invoice,
        _latestPaymentAttempt: _latestPaymentAttempt,
    }).fromJSON;
    function __updateOrigin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.invoice',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.invoices.api.v1.InvoicesService.UpdateOrigin',
            url: resolveComWixpressBillingInvoicesApiV1InvoicesServiceUrl({
                protoPath: '/v1/invoices/{id}/update-origin',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrigin.fromReq = fromReq;
    __updateOrigin.__isAmbassador = true;
    return __updateOrigin;
}
//# sourceMappingURL=http.impl.js.map